export default [
    {
        label: '姓名',
        name: "name",
        type: "input",
        rules: [{
            required: true,
            message:'请输入姓名'
           
        }],//字母数字，长度不能超过8位
        placeholder:'请输入姓名',
    },
    {
      label: '出生日期',
      name: "dateBirth",
      type: "dayPicker",
      disabledType:'2',
      rules: [{
        required: true,
        validator:(rule, value,callback)=>{
            if (value === '' || value == undefined ) {
                callback('请选择出生日期');
            } else{
                callback();
            }
        },
      }],
    },
    {
        label: '证件号码',
        name: "idCard",
        type: "input",
        rules: [{
            required: true,
            validator:(rule, value,callback)=>{
                if (value === '' || value == undefined ) {
                    callback('请输入证件号码');
                } else{
                    callback();
                }
            },
        }],
        placeholder:'请输入证件号码',
    },
    {
        label: '手机号',
        name: "mobile",
        type: "input",
        rules: [{
            required: true,
            message:'请输入手机号'
          
        }],
        placeholder:'请输入手机号',
    },
    {
        label: '住址',
        name: "address",
        type: "input", 
        placeholder:'请输入住址',
    },
    {
        label: '联系人',
        name: "contacts",
        type: "input", 
        placeholder:'请输入联系人',
    },
    {
        label: '验证码',
        name: "yzm",
        type: "VerificationCode",
        IdName:'userCanvas',//IdName 必填，不然报错
        rules: [{required: true, message: '请输入验证码'}],
        placeholder:'请输入验证码'
    },
    
]
